package com.essntl.features.proposal.domain.repository

import com.essntl.features.proposal.domain.model.ProposalFilterOptions
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.proposal.domain.model.fullproposal.FullProposalItineraryModel
import com.essntl.features.request.domain.model.RequestModel

interface ProposalRepository {
    suspend fun getAll(
        page: Long,
        limit: Int = 25,
        filterOptions: ProposalFilterOptions,
    ): Result<List<ProposalModel>>

    suspend fun getProposalsByClientId(clientId: String): Result<List<ProposalModel>>

    suspend fun getAllProposalByIds(ids: List<String>): Result<List<ProposalModel>>

    suspend fun getAllProposalServiceByStartDate(
        startDate: String,
        weeklyProposalServices: Boolean,
        proposalId: String,
    ): Result<List<ProposalServiceModel>>

    suspend fun getAllProposalServiceByStartDate(startDate: String): Result<List<ProposalServiceModel>>

    suspend fun getAllProposalServiceByIds(ids: List<String>): Result<List<ProposalServiceModel>>

    suspend fun getProposal(id: String): Result<ProposalModel>

    suspend fun getProposalByShareCode(shareCode: String): Result<ProposalModel?>

    suspend fun addProposal(proposal: ProposalModel): Result<ProposalModel>

    suspend fun updateProposal(proposal: ProposalModel): Result<ProposalModel>

    suspend fun getProposalHistoryList(proposalId: String): Result<List<ProposalModel>>

    suspend fun getProposalHistoryById(id: String): Result<ProposalModel>

    suspend fun getLatestProposalHistory(shareCode: String): Result<ProposalModel?>

    suspend fun getProposalHistory(shareCode: String, version: Int): Result<ProposalModel?>

    suspend fun addProposalHistory(proposal: ProposalModel): Result<ProposalModel>

    suspend fun addAllProposalService(proposalServiceList: List<ProposalServiceModel>): Result<List<ProposalServiceModel>>

    suspend fun getItineraryService(id: String): Result<ProposalServiceModel>

    suspend fun addAllItineraryService(itineraryServiceList: List<ProposalServiceModel>): Result<List<ProposalServiceModel>>

    suspend fun getAllProposalService(proposalId: String): Result<List<ProposalServiceModel>>

    suspend fun getAllProposalServiceByRange(
        proposalId: String,
        fromDate: String,
        toDate: String,
    ): Result<List<ProposalServiceModel>>

    suspend fun getAllProposalServiceBySupplierId(supplierId: String): Result<List<ProposalServiceModel>>

    suspend fun deleteAllProposalService(proposalId: String): Result<Unit>

    suspend fun deleteAllProposalService(ids: List<String>): Result<Unit>

    suspend fun deleteProposalService(proposalServiceId: String): Result<Unit>

    suspend fun updateProposalService(proposalService: ProposalServiceModel): Result<ProposalServiceModel>

    suspend fun updateProposalToItinerary(proposal: ProposalModel): Result<Unit>

    fun saveOpenedProposal(proposalId: String)

    suspend fun getLastOpenedProposals(): Result<List<ProposalModel>>

    suspend fun getCountProposalsByArea(areaId: String): Result<Long>

    suspend fun getFullProposalById(id: String): Result<FullProposalItineraryModel>

    suspend fun getFullProposalByShareCode(shareCode: String): Result<FullProposalItineraryModel>

    suspend fun getFullProposalHistory(shareCode: String, version: Int): Result<FullProposalItineraryModel>

    suspend fun getProposalsByTravelAgentId(travelAgentId: String): Result<List<ProposalModel>>

    suspend fun getProposalsByCoverImage(coverImageId: String): Result<List<ProposalModel>>

    suspend fun getCountProposalsHistoryByCoverImage(coverImageId: String): Result<Long>

    suspend fun updateProposalDaySummaries(proposalId: String): Result<Unit>

    suspend fun publishProposal(proposalId: String, description: String): Result<Unit>

    suspend fun updateProposalDates(proposalId: String, startDate: String): Result<Unit>

    suspend fun calculateServicePrice(proposalServiceId: String): Result<Unit>
}